
import {useStoreLocatorContext} from "../context/store-locator";
import Search from "./search";
import SearchResult from "./search-result";
import DealerDetail from "./dealer-detail";


const Sidebar = ()=>{
    const context  = useStoreLocatorContext();
    return (
        <div className={'store-locator-section '+(context.hideResult?'hide':'')}>
            <button className={'open-button'} onClick={()=>context.toggleHideResult()}>
                <span className={'icon-search'}></span>
            </button>
            <Search
                search={context.search}
                toggleHideResult={context.toggleHideResult}
            />
            {context.selectedDealer == null && (
                <SearchResult
                    dealers={context.dealers}
                    selectDealer={context.selectDealer}
                />
            )}
            {context.selectedDealer!=null && (
                <DealerDetail
                    dealer={context.selectedDealer}
                    onClose={()=>context.selectDealer(null)}
                />
            )}
        </div>
    )
}

export default Sidebar;
